export function extractArray<T = Record<string, unknown>>(data: unknown): T[] {
  return Array.isArray(data) ? (data as T[]) : [];
}

export function extractPaginated<T = Record<string, unknown>>(
  data: unknown
): { items: T[]; total: number } {
  const d = data as any;
  return {
    items: Array.isArray(d?.data) ? (d.data as T[]) : [],
    total: typeof d?.total === "number" ? d.total : 0,
  };
}
